import AbstractUnit from './AbstractUnit';
import { REF_SIZE, REF_SIZE_PT, SIZE_OPTIONS } from '../../../../constants/size';

const THREE = require('three');

class ObjectUnit extends AbstractUnit {
    constructor(data, webgl, markers) {
        super(data, webgl, null, markers);

        this._configView();
    }

    _setup(data, stgs, webgl) {
        super._setup(data, stgs, webgl);

        this.hasResize = true;
        this._orientation = '';
    }

    _configView() {
        this.mainView = new THREE.Group();
        this.add(this.mainView);
        this.resize(undefined, undefined, this._orientation, true);
    }

    start() {
        super.start();
    }

    resize(winWidth, winHeight, orientation, force, pixelRatio) {
        if (this.mainView.children.length < 1 && this.objects3D && this.objects3D.length > 0) {
            this.objects3D.forEach((obj3D) => {
                if (obj3D.parent) obj3D.parent.remove(obj3D);
                this.mainView.add(obj3D);
            });
        }

        let { position } = this.data;
        const sizeRef = orientation === SIZE_OPTIONS.LANDSCAPE ? REF_SIZE : REF_SIZE_PT;

        position = position ?? { x: 0, y: 0 };

        this.mainView.position.set(
            position.x * sizeRef.w * sizeRef.ratio.x,
            position.y * sizeRef.h * sizeRef.ratio.y,
            -this.mainViewZ
        );
        this.mainView.scale.set(
            sizeRef.previewScale,
            sizeRef.previewScale,
            sizeRef.previewScale
        );

        super.resize(winWidth, winHeight, orientation, force, pixelRatio);

        this.updateAnimationProgress();
    }
}

export default ObjectUnit;
